import type React from "react";
import { forwardRef } from "react";

import { twMerge } from "tailwind-merge";

import { InputField as AlpacaInputField } from "@alpacahq/ui";

export type InputFieldProps = React.ComponentProps<typeof AlpacaInputField>;

const TAILWIND_FORMS_INPUT_RESET =
  "[&_input]:border-0 [&_input]:p-0 [&_input]:shadow-none [&_input]:ring-0 [&_input]:outline-none [&_input]:focus:border-0 [&_input]:focus:ring-0 [&_input]:focus:shadow-none [&_input]:focus:outline-none [&_p]:mb-0 [&_p]:pb-0";

// @tech-debt
// Algodash uses @tailwindcss/forms globally; reset its inner input styles.
export const InputField = forwardRef<HTMLInputElement, InputFieldProps>(
  ({ className, ...props }, ref) => (
    <AlpacaInputField
      ref={ref}
      className={twMerge(TAILWIND_FORMS_INPUT_RESET, className)}
      {...props}
    />
  ),
);

InputField.displayName = "InputField";
